export default __webpack_public_path__ + "6dde18cb054d36d44a5b15dc9e39f815.png";